/**
 * Subscription statuses Stripe still runs (`active`, `trialing`, `past_due` – it may still collect):
 * such a subscription is changed in Stripe, the customer manages it in the portal.
 * `RUNNING_STATUSES` of packages/shared (SP-A2.170), a test holds this copy to it. Access and
 * revenue, which also end after the dunning, are the API's (`access`, MRR).
 */
export const RUNNING_STATUSES: readonly string[] = ['active', 'trialing', 'past_due'];

export const isRunning = (sub: { status: string } | null | undefined) =>
  sub ? RUNNING_STATUSES.includes(sub.status) : false;
